export const SET_ALL_GAMES       = 'set_all_games';
export const UPDATE_GAME_ICON    = 'update_game_icon';
export const NAV_IS_PAGE_SCROLL  = 'nav_is_page_scroll';
export const DEMO_DIALOG_IS_SHOW = 'demo_dialog_is_show';
export const FORM_DIALOG_IS_SHOW = 'form_dialog_is_show';
export const CURRENT_GAME_ID     = 'current_game_id';
export const MOBILE_MENU_FLAG    = 'mobile_menu_flag';
export const CACHE_KEY           = 'gameInfosCache';
export const CACHE_EXPIRE        = 1000 * 60 * 60 * 24;// 24小时，单位毫秒
